import React, { useState, useEffect } from "react";
import { Grid } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";

import { ChangeStressActionCreators } from "redux/rootActions";
import { changeStressDataResponse } from "redux/stressCheck/changeStress/changeStressStates";

import { localStorageHelper } from "utils";
import { Select, Button } from "components";
import { CircleArrow } from "icons";
import { CheckboxStyled } from "screens/account/Account.style";

import ChangesLineChart from "./ChangesLineChart";
import {
  WapperSelectTimeForItem,
  HeaderSection,
  ChartContentContainer,
  CheckboxChartItem,
  StressLineChartWrapper,
  RadarChartSelectWrapper,
  DescriptionHeaderBlock,
  DescriptionTable,
  LineChartHeaderGroup,
  WrapperHeader1,
  WrapperHeader2,
} from "../Stress.style";

const { useBreakpoint } = Grid;

const yearOptions: any = [];
for (let i = 2000; i <= 2030; i++) {
  yearOptions.push({
    key: i,
    value: i,
    // name: i + "年",
    name: i,
  });
}

const monthOptions: any = [];
for (let i = 1; i <= 12; i++) {
  monthOptions.push({
    key: i,
    value: i,
    // name: i + "月",
    name: i,
  });
}

const ChangesInStress: React.FC<any> = () => {
  const currentLanguage = localStorageHelper.getItem("i18nextLng");
  const { t }: any = useTranslation("translation", {
    keyPrefix: "stress-check",
  });
  const { t: t1 }: any = useTranslation("translation", {
    keyPrefix: "account",
  });
  const screens = useBreakpoint();

  const dispatch = useDispatch();

  const { handleSubmit, control } = useForm();

  const changeStressData = useSelector(changeStressDataResponse);
  const [data, setData] = useState<any>({
    list: [],
    changeData: [],
  });

  const handleChange = (id: any) => {
    if (data.list) {
      const tempCheckDatas = [...data.list];
      tempCheckDatas[id].checked = !tempCheckDatas[id].checked;
      setData({
        ...data,
        list: tempCheckDatas,
      });
    }
  };

  const onSubmit = (data: any) => {
    dispatch(
      ChangeStressActionCreators.changeStressAction({
        start_year: data.startYear || "",
        start_month: data.startMonth || "",
        end_year: data.endYear || "",
        end_month: data.endMonth || "",
      })
    );
  };

  useEffect(() => {
    dispatch(
      ChangeStressActionCreators.changeStressAction({
        start_year: "",
        start_month: "",
        end_year: "",
        end_month: "",
      })
    );
  }, []);

  useEffect(() => {
    dispatch(ChangeStressActionCreators.handleResetDataAction());
    setData({
      list: [],
      changeData: [],
    });
  }, []);

  useEffect(() => {
    if (changeStressData && Object.keys(changeStressData).length) {
      const tempChangeData: any = [];
      changeStressData?.result?.month_vise_data.map(
        (lineItem: any, index: number) => {
          tempChangeData[index] = {
            date: Object.keys(lineItem)[0],
          };
          lineItem[Object.keys(lineItem)[0]].map((item: any, idx: number) => {
            tempChangeData[index] = {
              ...tempChangeData[index],
              [idx]: item.data,
            };
          });
        }
      );
      setData({
        list: changeStressData.result.percentage_with_stress_check.map(
          (item: any, idx: number) => {
            return {
              id: idx,
              title: item.title,
              fill: item.color,
              checked: false,
              compare: item.percentage_with_stress_check,
              shape: item.shape,
              status: item.percentage_data + "%",
            };
          }
        ),
        changeData: tempChangeData,
      });
    }
  }, [changeStressData]);

  const returnShape = (shape: string, fill: string) => {
    switch (shape) {
      case "Square":
        return <div className="square" style={{ background: fill }} />;
      case "Triangle":
        return <div className="triangle" style={{ borderBottomColor: fill }} />;
      default:
        return <div className="circle" style={{ background: fill }} />;
    }
  };

  const returnCircle = (status: string) => {
    switch (status) {
      case "decrease":
        return (
          <CircleArrow
            style={{ transform: "rotate(45deg)" }}
            fillPath="#2AC769"
          />
        );
        break;
      case "increase":
        return (
          <CircleArrow
            style={{ transform: "rotate(-45deg)" }}
            fillPath="#FB4E4E"
          />
        );
        break;
      default:
        return <CircleArrow fillPath="#CCCCCC" />;
    }
  };

  const handleHeaderChangeStressChart = () => {
    const screenWidth = screen.width;
    if (screenWidth <= 375) {
      return (
        <DescriptionHeaderBlock>
          <div
            style={{
              padding:
                currentLanguage === "vi" ? "5px 0px 16px" : "5px 9px 16px",
            }}
          >
            {t("compare-previous-month")}
          </div>
          <div>{t("current-situation")}</div>
        </DescriptionHeaderBlock>
      );
    }
    if (screenWidth >= 768 && screenWidth <= 991) {
      return (
        <WrapperHeader1>
          <DescriptionHeaderBlock>
            <div
              style={{
                padding:
                  currentLanguage === "vi" ? "5px 0px 16px" : "5px 9px 16px",
              }}
            >
              {t("compare-previous-month")}
            </div>
            <div>{t("current-situation")}</div>
          </DescriptionHeaderBlock>
          <DescriptionHeaderBlock>
            <div
              style={{
                padding:
                  currentLanguage === "vi" ? "5px 0px 16px" : "5px 9px 16px",
              }}
            >
              {t("compare-previous-month")}
            </div>
            <div>{t("current-situation")}</div>
          </DescriptionHeaderBlock>
        </WrapperHeader1>
      );
    }
    return (
      <WrapperHeader2>
        <DescriptionHeaderBlock>
          <div
            style={{
              padding:
                currentLanguage === "vi" ? "5px 0px 16px" : "5px 9px 16px",
            }}
          >
            {t("compare-previous-month")}
          </div>
          <div>{t("current-situation")}</div>
        </DescriptionHeaderBlock>
        <DescriptionHeaderBlock>
          <div
            style={{
              padding:
                currentLanguage === "vi" ? "5px 0px 16px" : "5px 9px 16px",
            }}
          >
            {t("compare-previous-month")}
          </div>
          <div>{t("current-situation")}</div>
        </DescriptionHeaderBlock>
        <DescriptionHeaderBlock>
          <div
            style={{
              padding:
                currentLanguage === "vi" ? "5px 0px 16px" : "5px 9px 16px",
            }}
          >
            {t("compare-previous-month")}
          </div>
          <div>{t("current-situation")}</div>
        </DescriptionHeaderBlock>
      </WrapperHeader2>
    );
  };

  return (
    <>
      <StressLineChartWrapper>
        <HeaderSection>
          <LineChartHeaderGroup>
            <div
              style={{
                fontWeight: 700,
                fontSize: 16,
                lineHeight: "16px",
              }}
            >
              {t("change-in-stress")}
            </div>
            <WapperSelectTimeForItem>
              <RadarChartSelectWrapper onSubmit={handleSubmit(onSubmit)}>
                <div className="bor-div-time">
                  <div
                    style={{
                      fontWeight: 500,
                      fontSize: 14,
                      lineHeight: "16px",
                      color: "#666666",
                      marginRight: 8,
                    }}
                  >
                    {t("graph-display-period")}
                  </div>
                  <div className="dleft">
                    <Controller
                      control={control}
                      name="startYear"
                      render={({ field: { onChange } }) => (
                        <Select
                          options={yearOptions}
                          width={"100px"}
                          placeholder="2025"
                          height="30px"
                          onChange={onChange}
                        />
                      )}
                    />
                    <Controller
                      control={control}
                      name="startMonth"
                      render={({ field: { onChange } }) => (
                        <Select
                          options={monthOptions}
                          width={"82px"}
                          placeholder="01"
                          height="30px"
                          marginForm="0px 0px 0px 8px"
                          onChange={onChange}
                        />
                      )}
                    />
                    <span style={{ padding: "0px 8px", lineHeight: "30px" }}>
                      〜
                    </span>
                  </div>
                  <div className="dright">
                    <Controller
                      control={control}
                      name="endYear"
                      render={({ field: { onChange } }) => (
                        <Select
                          options={yearOptions}
                          width={"100px"}
                          placeholder="2025"
                          height="30px"
                          onChange={onChange}
                        />
                      )}
                    />
                    <Controller
                      control={control}
                      name="endMonth"
                      render={({ field: { onChange } }) => (
                        <Select
                          options={monthOptions}
                          width={"82px"}
                          placeholder="01"
                          height="30px"
                          marginForm="0px 0px 0px 8px"
                          onChange={onChange}
                        />
                      )}
                    />
                  </div>
                </div>
                <Button
                  color="#FFFFFF"
                  fontSize={16}
                  fontWeight={700}
                  lineHeight="23px"
                  background="#2AC769"
                  padding="3px 12px"
                  name={t1("update")}
                  bdr="6px"
                  border="none"
                />
              </RadarChartSelectWrapper>
            </WapperSelectTimeForItem>
          </LineChartHeaderGroup>
          {/* <div
              style={{
                padding: currentLanguage === "vi" ? "5px 0px 16px" : "5px 9px 16px",
              }}
            >
              {t("compare-previous-month")}
            </div>
            <div>{t("current-situation")}</div> */}
        </HeaderSection>

        <ChartContentContainer>
          <div className="chart-section">
            <ChangesLineChart data={data.changeData} checkData={data.list} />
          </div>
          <div>
            {handleHeaderChangeStressChart()}

            <DescriptionTable>
              {data.list.map((item: any, idx: any) => (
                <div className="block" key={idx}>
                  <div className="checkbox-section">
                    <CheckboxChartItem key={item.id}>
                      <CheckboxStyled
                        checked={item.checked}
                        onChange={() => handleChange(item.id)}
                      />
                      <div className="dot-text">
                        {returnShape(item.shape, item.fill)}
                        <div
                          className="dot"
                          style={{ background: "#2A98C7" }}
                        />
                        <div>{item.title}</div>
                      </div>
                    </CheckboxChartItem>
                    <div className="right">
                      <div>{returnCircle(item.compare)}</div>
                      <div>{item.status}</div>
                    </div>
                  </div>
                </div>
              ))}
            </DescriptionTable>
          </div>
        </ChartContentContainer>
      </StressLineChartWrapper>
    </>
  );
};

export default ChangesInStress;
